import { AppConfig } from '@/utils/AppConfig';

export default function getDirectusImageUrl(
  directusImageId: string,
  publicUrl: boolean = false,
  width?: number,
  height?: number,
  fit?: 'inside' | 'outside' | 'cover' | 'fill' | 'contain' | 'inside' | 'outside',
  format?: string,
  quality?: number,
): string {
  let params = '';
  if (width) {
    params += `&width=${width}`;
  }
  if (height) {
    params += `&height=${height}`;
  }
  if (fit) {
    params += `&fit=${fit}`;
  }
  if (format) {
     params += `&format=${format}`;
  }
  if (quality) {
    params += `&quality=${quality}`;
  }

  if (params) {
    params = '?' + params.slice(1);
  }

  const directusImageUrl = `${!publicUrl ? AppConfig.directusUrl : AppConfig.directusPublicUrl}/assets/${directusImageId}${params}`;

  return directusImageUrl;
}
